import {MapControl, MapControlProps, withLeaflet} from 'react-leaflet';
import L from "leaflet";

interface GrayScaleButtonProps extends MapControlProps {
    toggleGrayScale: Function,
    grayscaleEnabled: boolean
}

class GrayScaleButton extends MapControl<GrayScaleButtonProps, L.Control.EasyButton> {

    createLeafletElement(props: GrayScaleButtonProps): L.Control.EasyButton {

        return new L.Control.EasyButton({
            id: 'togglemapgrayscale',
            position: 'bottomleft',
            states: [
                {
                    stateName: 'disabled',
                    icon: 'map-icon-grayscale',
                    title: 'Klikk for gråtonekart',
                    onClick: () => {
                        this.props.toggleGrayScale();
                    }
                },
                {
                    stateName: 'enabled',
                    icon: 'map-icon-color',
                    title: 'Klikk for fargekart',
                    onClick: () => {
                        this.props.toggleGrayScale();
                    }
                }
            ]
        });
    }

    componentDidUpdate () {
        this.props.grayscaleEnabled
            ? this.leafletElement.state('enabled')
            : this.leafletElement.state('disabled')
    }

}

export default withLeaflet(GrayScaleButton);
